import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.scss";
import AboutContainer from "./Container/CMSPagesContainer/AboutContainer";
import ContactContainer from "./Container/CMSPagesContainer/ContactContainer";
import IPContainer from "./Container/CMSPagesContainer/InsurancePartnersContainer";
import HomeContainer from "./Container/HomeContainer/HomeContainer";
import CrmContainer from "./Container/ProductPageContainer/CrmContainer";
import EBContainer from "./Container/ProductPageContainer/EBContainer";
import ErpContainer from "./Container/ProductPageContainer/ErpContainer";
import IGContainer from "./Container/ProductPageContainer/InsuranceAggregationContainer";
import IntegrationExcellenceContainer from "./Container/ProductPageContainer/IntegrationExcellenceContainer";
import IntegrationServicesContainer from "./Container/ProductPageContainer/IntegrationServicesContainer";
import OTJourneyContainer from "./Container/ProductPageContainer/OTJourneyContainer";
import PospContainer from "./Container/ProductPageContainer/PospContainer";
import SIContainer from "./Container/ProductPageContainer/SelfInspectionContainer";
import { ALL_ROUTES } from "./Routes/AllRoutes";

const AppRouters = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Routes>
        <Route path={ALL_ROUTES.HOMEPAGE} element={<HomeContainer />} />
        <Route path={ALL_ROUTES.CRM} element={<CrmContainer />} />
        <Route path={ALL_ROUTES.POSP} element={<PospContainer />} />
        <Route path={ALL_ROUTES.ERP} element={<ErpContainer />} />
        <Route path={ALL_ROUTES.EB} element={<EBContainer />} />
        <Route path={ALL_ROUTES.SELF_INSPECTION} element={<SIContainer />} />
        <Route path={ALL_ROUTES.INSURANCE_AGGREGATION} element={<IGContainer />} />
        <Route path={ALL_ROUTES.CONTACTUS} element={<ContactContainer />} />
        <Route path={ALL_ROUTES.ABOUT} element={<AboutContainer />} />
        <Route path={ALL_ROUTES.INSURANCE_PARTNERS} element={<IPContainer />} />
        <Route path={ALL_ROUTES.INTEGRATION_SERVICES} element={<IntegrationServicesContainer />} />
        <Route path={ALL_ROUTES.OT_JOURNEY} element={<OTJourneyContainer />} />
        <Route path={ALL_ROUTES.INTEGRATION_EXCELLENCE} element={<IntegrationExcellenceContainer />} />
      </Routes>
    </>
  )
}

function App() {
  return (
    <>
      <BrowserRouter>
        <AppRouters />
      </BrowserRouter>
    </>
  );
}

export default App;